import { render, staticRenderFns } from "./task-complete.vue?vue&type=template&id=f948c27a&"
import script from "./task-complete.vue?vue&type=script&lang=js&"
export * from "./task-complete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports